export const isEmail = data => {
  if (/^\S+@\S+\.\S+$/.test(data)) {
    return data;
  }

  return null;
};
